import type { IconData } from '@stacksjs/iconify-core'

export const id1x1: IconData = {
  "body": "<path fill=\"#e70011\" d=\"M0 0h512v256H0Z\"/><path fill=\"#fff\" d=\"M0 256h512v256H0Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default id1x1
